import React from "react";
import { useAppSelector } from "../hooks";
import { selectLayerById } from "../slices/layers";
import { useLayerGeoJSONByID } from "./fetchGeoJSON";

import { isDefined } from "../lib/utils";

export function useGetLayerFeature(
  layerId?: number | string,
  featureId?: number | string
) {
  const { geojson } = useLayerGeoJSONByID(layerId);
  if (!isDefined(featureId)) return;
  const feature = geojson?.features?.find((f) => `${f.id}` === `${featureId}`);
  return feature;
}
export function useSelectedFeature() {
  const selected = useAppSelector(
    (state) => state.mapState.selectedFeature ?? []
  );
  const [layerId, featureId] = selected;
  const layer = useAppSelector((state) => {
    return selectLayerById(state, layerId);
  });
  const { geojson, layerProps, actions } = useLayerGeoJSONByID(layerId);
  if (!layer || layer?.type !== "vector") return {};

  const feature = geojson?.features?.find((f) => `${f.id}` === `${featureId}`);

  const labelProperty =
    layerProps?.style?.labelProperty ??
    layerProps?.options?.searchFields?.[0] ??
    Object.keys(feature?.properties ?? []).find((p) =>
      ["name", "title", "label", "id"].includes(p.toLowerCase())
    );

  return {
    feature,
    layer,
    labelProperty,
    actions,
  };
}
